/**
 * documentation at
 * https://webartelier.de/fee_doc/list_classes.html#formvalidation
 */


class FormValidation {

  static init = (params) => {
    const selForm = `${params.selForm}:not(.has-validation)`;
    const allForms = document.querySelectorAll(selForm);

    allForms.forEach(form => {
      new FormValidation(form, params);
    })
  }



  constructor(form, params) {
    this.form = form;
    this.availableLocales = params.availableLocales;
    this.config = params['config'];

    this.initForm();
  }



  initForm = () => {
    const validation = new Pristine(this.form, this.config);
    Pristine.setLocale(this.getLocale(this.availableLocales));

    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.markSubmitted();
      if (validation.validate()) this.form.submit();
    });

    this.markInitialized();
  }



  markInitialized = () => {
    this.form.classList.add('has-validation');
  }



  markSubmitted = () => {
    this.form.classList.add('is-submitted');
  }



  getLocale = (availableLocales) => {
    const docLang = document.documentElement.lang;
    let locale = 'en';

    if (availableLocales.includes(docLang)) locale = docLang;
    
    return locale;
  }
}